import type { ApiResponse } from '../../../../../config/api-types'
import type { CreateCollectionOrderRequest } from '../../../domain/models/create-collection-order'
import * as types from '../types/create-collection-order-types'

export const createCollectionOrderRequest = (
  payload: CreateCollectionOrderRequest,
) => ({
  type: types.CREATE_COLLECTION_ORDER_REQUEST,
  payload,
})

export const createCollectionOrderError = (payload: string) => ({
  type: types.CREATE_COLLECTION_ORDER_ERROR,
  payload,
})

export const createCollectionOrderSuccess = (payload: ApiResponse) => ({
  type: types.CREATE_COLLECTION_ORDER_SUCCESS,
  payload,
})

export const createCollectionOrderReset = () => ({
  type: types.CREATE_COLLECTION_ORDER_RESET,
})
